import { MdKeyboardArrowRight } from "react-icons/md";
import styles from "./Others.module.css";

interface IProps {
    handleClick: () => void,
    style?: { [key: string]: string }
}


const NextIconButton: React.FC<IProps> = ({ handleClick, style }) => {

    return (
        <button 
            className = {styles.next_icon_btn} 
            onClick = {handleClick}
            style = {style}
        >
            <MdKeyboardArrowRight 
                size = "1.5rem"
                color = "white"
            />
        </button>
    );

}


export default NextIconButton;
